// extracted by mini-css-extract-plugin
export default {"offerer-list":"offerer-list--pot1R","offererList":"offerer-list--pot1R","offerer-list__offerer":"offerer-list__offerer--zsvj2","offererListOfferer":"offerer-list__offerer--zsvj2"};